<template>
  <!-- Self Signup Page  Config -->
  <div class="row plan_row">
    <div class="col-6 ace_sec_txt title">
      {{detail}}
    </div>
    <div class="col-6 btn_container">
      <b-button class="btn" aria-label="Config" @click="navigateToAction" v-if="action">{{this.actionButton}}</b-button>
    </div>
  </div>
  <!-- Self Signup Page  Config  Ends -->
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'institution-setting-row',
  props: ['uuid','detail', 'action', 'actionButton'],
  methods: {
    navigateToAction () {
/*      if(this.action==='alumniInsight'){
          return this.$router.push('/alumniInsight/bulkUpload')
      }else if(this.action==='alumniInsight'){
          return this.$router.push('/alumniInsight/bulkUpload')
      }else if(this.action==='alumniInsight'){
          return this.$router.push('/alumniInsight/bulkUpload')
      }else {
        return this.$router.push({ name: this.action, params: { uuid: this.uuid } })
      }
*/
      return this.$router.push({ name: this.action, params: { uuid: this.uuid } })
    }
  }
}
</script>
<style>
.institution-left-panel {
	.institution-left-panel {
		max-width:164px;
	}
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionSettingRow.vue